import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var LiveViewDisabledIcon = createIcon({
  displayName: 'LiveViewDisabledIcon',
  viewBox: '0 0 24 24',
  path: [/*#__PURE__*/_jsx("path", {
    d: "M21.2 2.09995C21.4 1.89995 21.7 1.89995 21.9 2.09995C22.1 2.29995 22.2368 2.53957 21.8 2.99995L15.4 9.39995L18.4 11.2C19.2 11.7 19.2 12.5 18.4 13L6.49999 20.3C5.69999 20.7 4.99999 20.5 4.99999 19.7L2.89999 21.8C2.69999 22 2.39999 22 2.19999 21.8C1.99999 21.6 1.99999 21.3 2.19999 21.1L21.2 2.09995Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4.99999 4.39995C4.99999 3.49995 5.69999 3.19995 6.49999 3.79995L13.7 8.19995L4.99999 16.9V4.39995Z",
    fill: "currentColor"
  })]
});
//# sourceMappingURL=LiveViewDisabledIcon.js.map